import $ from 'jquery';

export default (context, data) => {
  const dfd = $.Deferred();

  setTimeout(() => {
    dfd.resolveWith(context, [data]);
  }, 200);

  return dfd.promise();
};
